<template>
    <div class="mismatch-step">
        <p class="mismatch-text">
            We couldn't find a match for your email and the profile you are claiming in our
            records. But don't worry, one of our team members will contact you shortly to help
            validate your email address.
        </p>
        <div class="actions">
            <button @click="toggleClaimProfile(false)" class="cta-btn">Close</button>
        </div>
    </div>
</template>
<script>
    import { useArtistClaimProfile } from '@/composables/features/artist-claim-profile/useArtistClaimProfile'

    export default {
        name: 'MismatchStep',
        setup() {
            const { toggleClaimProfile } = useArtistClaimProfile()
            return {
                toggleClaimProfile
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    $mobileMax: 600px;

    @media screen and (max-width: $mobileMax) {
        .mismatch-text {
            padding-left: 0px !important;
            padding-right: 0px !important;
            padding-bottom: 40px !important;
            border-bottom: none !important;
        }
        .actions {
            padding-left: 0px !important;
            padding-right: 0px !important;

            .cta-btn {
                width: 100%;
            }
        }
    }
    button {
        border: none;
    }
    p {
        margin-bottom: 0px;
    }
    .mismatch-step {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .mismatch-text {
            padding-top: 0px;
            padding-bottom: 34px;
            border-bottom: 1px solid #333333;
            padding-left: 56px;
            padding-right: 56px;
            color: #8b8b8b;
            @include base-font-16;
            line-height: 125%;
        }
        .actions {
            width: 100%;
            padding: 16px 24px;

            .cta-btn {
                margin-left: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 12px 32px;
                border-radius: 120px;
                background: #cdeb09;
                color: #000;
                @include base-font-18;
                line-height: 133%;
            }
            .cta-btn:disabled {
                opacity: 0.5;
            }
        }
    }
</style>
